export * from "./vertexOutputBlock";
export * from "./bonesBlock";
export * from "./instancesBlock";
export * from "./morphTargetsBlock";
export * from "./lightInformationBlock";

// async-loaded shaders

// bonesBlock
export * from "../../../../ShadersWGSL/ShadersInclude/bonesDeclaration";
export * from "../../../../ShadersWGSL/ShadersInclude/bonesVertex";
export * from "../../../../Shaders/ShadersInclude/bonesDeclaration";
export * from "../../../../Shaders/ShadersInclude/bonesVertex";

// morphTargetsBlock
export * from "../../../../ShadersWGSL/ShadersInclude/morphTargetsVertex";
export * from "../../../../ShadersWGSL/ShadersInclude/morphTargetsVertexDeclaration";
export * from "../../../../ShadersWGSL/ShadersInclude/morphTargetsVertexGlobal";
export * from "../../../../ShadersWGSL/ShadersInclude/morphTargetsVertexGlobalDeclaration";
export * from "../../../../Shaders/ShadersInclude/morphTargetsVertex";
export * from "../../../../Shaders/ShadersInclude/morphTargetsVertexDeclaration";
export * from "../../../../Shaders/ShadersInclude/morphTargetsVertexGlobal";
export * from "../../../../Shaders/ShadersInclude/morphTargetsVertexGlobalDeclaration";
